import React from "react";

function SectionTitle({ children }) {
  return <div>{children}</div>;
}

export default SectionTitle;
